const CALENDAR_CLASSIFICATION_BADGES = {
  past: ["gray", "Past"],
  canceled: ["error", "Canceled"],
  postponed: ["warning", "Postponed"],
  on_sale: ["purple", "On Sale"],
  pre_sale: ["orange", "Pre Sale"],
  announced: ["success", "Announced"],
};

export const calendarClassificationBadge = (classification) => (
  CALENDAR_CLASSIFICATION_BADGES[classification] || ["blue", "Confirmed"]
);
